import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { HelpIndex, EntryType, Endpoint } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import * as _ from 'underscore';

@Component({
    standalone: false,
    selector: 'res-aliases-domain-entries-modal',
    templateUrl: './add-aliases-domain-entries-modal.component.html',
    styleUrls: ['./add-aliases-domain-entries-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class AddAliasesDomainEntriesModalComponent extends BaseModalComponent implements OnInit {
    modalTitle = '';
    modalAutomationId = 'add-edit-aliases-domains-template';
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel = 'OK';
    verifyRequiredValidator = true;
    isBusy = false;
    isBusyMessage = '';
    modalHelpIndex: any;
    modalClass = 'aliases-domainEntries-modal';
    allEntries = [{ name: '' }];
    availableEntries = [];

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        if (this.modalData.entryType === EntryType.aliases) {
            this.modalTitle = 'Add Aliases';
            this.modalHelpIndex = HelpIndex.myedisc_add_alias_dlg;
            this.availableEntries = this.modalData.listSelected.aliases;
        } else if (this.modalData.entryType === EntryType.domainEntries) {
            this.modalTitle = 'Add Domains';
            this.modalHelpIndex = HelpIndex.myedisc_add_domain_dlg;
            this.availableEntries = this.modalData.allDomainEntries;
        }
    }

    isPrimaryButtonEnabled() {
        return this.allEntries.length > 1;
    }

    newFileUploaded($event): void {
        this.readFileContent($event.target);
    }

    readFileContent(inputValue: any): void {
        const file: File = inputValue.files[0];
        const fileReader: FileReader = new FileReader();

        fileReader.onloadend = e => {
            let result: string[];
            if (fileReader.result instanceof ArrayBuffer) {
                result = String.fromCharCode.apply(null, new Uint16Array(fileReader.result));
            } else {
                result = fileReader.result.split('\n');
            }
            result = _.uniq(result);

            const newEntries = [];
            result.forEach((entry, index) => {
                return newEntries[index] = {
                    name: entry.trim()
                };
            });

            this.allEntries = _.reject(this.allEntries, function (entry) { return entry.name === ''; });

            newEntries.forEach((entry) => {
                this.allEntries.push(entry);
            });

            this.allEntries.push({ name: '' });
        };

        fileReader.readAsText(file);
    }

    clearAllEntries() {
        this.allEntries = [];
        this.allEntries.push({ name: '' });
    }

    OK() {
        const endpoint = this.modalData.entryType === EntryType.aliases ? Endpoint.projectManager_updateAliasList : Endpoint.projectManager_updateDomain;
        let request = {},
            listEntries = [],
            aliasRequest = {},
            domainRequest = {};

        this.availableEntries.forEach((avialableEntry) => {
            listEntries.push(avialableEntry);
        });

        this.allEntries.forEach((singleEntry) => {
            if (singleEntry.name !== '') {
                listEntries.push(singleEntry.name);
            }
        });

        listEntries = _.uniq(listEntries);

        aliasRequest = {
            handle: this.modalData.listSelected.handle,
            description: this.modalData.listSelected.description,
            name: this.modalData.listSelected.name,
            aliases: listEntries
        };

        domainRequest = {
            description: this.modalData.listSelected.description,
            domainEntries: listEntries,
            handle: this.modalData.listSelected.handle,
            name: this.modalData.listSelected.name,
            updateOperation: 'ADD_ENTRIES',
            systemScope: this.modalData.systemScope
        };

        request = this.modalData.entryType === EntryType.aliases ? aliasRequest : domainRequest;

        this.restService.post(endpoint, request).then(response => {
            this.closeModal(true, response);
        }, error => {
            console.error(error);
        });
    }
}
